export const toPx = (value: unknown) => {
  const px = 'px'
  if (typeof value === 'number') {
    return value + px;
  }

  if (typeof value === 'string') {
    if (value.includes('px')) {
      return value;
    }

    if (value.includes('rem')) {
      return +value.replace('rem', '') * 16 + px;
    }

    if (value.includes('em')) {
      return +value.replace('em', '') * 16 + px;
    }

    if (!isNaN(+value)) {
      return value + px
    }

    return value

  }

  return undefined;
}